import React from "react";
import { History } from "lucide-react";
import { Card } from "@/components/common";
import { useWP } from "./wpApi";

const TYPE = { created: "Auftrag angelegt", updated: "Angaben geändert", logo: "Logo gespeichert", archived: "Auftrag archiviert" };

function Change({ c }) {
  const { field, fmtValue } = useWP();
  return (
    <li className="text-xs text-gray-400 break-words">
      <span className="text-gray-300 font-semibold">{field(c.field)}:</span>{" "}
      {c.old !== null && c.old !== undefined && <><span className="line-through decoration-white/30">{fmtValue(c.field, c.old)}</span> → </>}
      <span className="text-white">{fmtValue(c.field, c.new)}</span>
    </li>
  );
}

export default function WPHistory({ events }) {
  const { t, status, fmtDate } = useWP();
  return (
    <Card className="p-5 sm:p-6" data-testid="wp-history">
      <h2 className="flex items-center gap-2 text-sm font-bold uppercase tracking-[0.16em] text-gray-400 mb-4"><History className="w-4 h-4" /> {t("Verlauf")}</h2>
      {events.length === 0 ? <p className="text-sm text-gray-500">{t("Noch keine Einträge.")}</p> : (
        <ol className="relative border-l border-white/10 ml-1.5 space-y-5">
          {events.map((ev) => (
            <li key={ev.id} className="pl-5 relative" data-testid={`wp-history-${ev.type}`}>
              <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-[#A3E635]" />
              <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
                <span className="text-sm font-semibold text-white">{TYPE[ev.type] ? t(TYPE[ev.type]) : ev.type}</span>
                <span className="font-mono text-[11px] text-gray-500">v{ev.revision}</span>
                <span className="text-[11px] text-gray-500">{fmtDate(ev.at)} · {ev.actor?.name || ev.actor?.email}</span>
              </div>
              {ev.status_from !== ev.status_to && ev.status_to && (
                <div className="mt-0.5 text-xs text-gray-400">{t("Status")}: {ev.status_from ? `${status(ev.status_from)} → ` : ""}<span className="text-[#A3E635]">{status(ev.status_to)}</span></div>
              )}
              {ev.preset_name && <div className="mt-0.5 text-xs text-gray-400">{t("Vorlage")}: {ev.preset_name}</div>}
              {ev.changes?.length > 0 && <ul className="mt-1.5 space-y-0.5">{ev.changes.map((c) => <Change key={c.field} c={c} />)}</ul>}
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
